import { CUSTOM_FIELD_TYPES } from '@webapp-next/modules/schedule/definitions';

export default {
  CUSTOM_FIELD_TYPES,
};
